import React, { useState, useEffect } from "react";
import "./PathologyRecord.css";
import { useParams, useNavigate } from "react-router-dom";
import { useApp } from "./../../../../../AppProvider";
import api from "./../../../../../axiosInstance"

const HospitalizationRecord = () => {
  const { patientsMHR } = useApp();
  const [fileUrls, setFileUrls] = useState([]);
  const navigate = useNavigate();
  let { recordId } = useParams();

  if (recordId === undefined) {
    recordId = patientsMHR[0].recordId;
    navigate(`/DashboardDashboardNavigation/records/${recordId}`);
  }

  const record = patientsMHR.find((item) => item.recordId === recordId);

  useEffect(() => {
    const fetchPdfs = async () => {
      const urls = await Promise.all(
        record.files.map(async (fileId) => {
          const response = await api.get(`/uploads/${fileId}`, {
            responseType: 'blob'
          });
          return URL.createObjectURL(response.data);
        })
      );
      setFileUrls(urls);
    };

    if (record.files && record.files.length > 0) {
      fetchPdfs();
    }
  }, [record]);

  return (
    <div className="card-container-main">
      <div className="card-container-records">
        <div className="card-records one">
          <h2 className="card-heading-1">Hospitalization Record</h2>
          <ul className="card-bottom-text">
            {record.hospitalizations.map((item, index) => (
              <li className="testName-section" key={index}>
                {item.hospitalName}:{" "}
                <span className="card-bottom-text-count">{item.admissionDate}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
      {fileUrls && fileUrls.length > 0 && (
        fileUrls.map((url, index) => (
          <div className="pdf-container" key={index}>
            <iframe
              className="pdf-viewer"
              src={url}
              title={`PDF Viewer ${index}`}
              width="100%"
              height="600px"
            />
          </div>
        ))
      )}
    </div>
  );
};

export default HospitalizationRecord;
